import PropTypes from 'prop-types';
import React from 'react';

export const MfeRetracementWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'MFE_RETRACEMENT',
    category: 'Exit',
    type: 'MFE Retracement',
    domain: 'Underlying',
  };
  const isInRetrace = softOrder.isInRetraceState;
  const maxMfe = softOrder.maxMfe;
  const retraceFromMfe = softOrder.retraceFromMfe;
  const activateMfe = softOrder.activateMfe;
  const activateMfePositionPrice = softOrder.activateMfePositionPrice;
  const retraceMfePositionPrice = softOrder.retraceMfePositionPrice;

  return (
    <Component
      details={details}
      isInRetrace={isInRetrace}
      maxMfe={maxMfe}
      retraceFromMfe={retraceFromMfe}
      activateMfe={activateMfe}
      activateMfePositionPrice={activateMfePositionPrice}
      retraceMfePositionPrice={retraceMfePositionPrice}
      {...rest}
    />
  );
};

MfeRetracementWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    activateMfe: PropTypes.any,
    activateMfePositionPrice: PropTypes.any,
    isInRetraceState: PropTypes.any,
    maxMfe: PropTypes.any,
    retraceFromMfe: PropTypes.any,
    retraceMfePositionPrice: PropTypes.any,
  }),
};
